import { AxiosError } from 'axios'

import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query'

import { cadastrarRepostaCliente, cadastrarRetornoCliente, fetchContatos, fetchPesquisaSatisfacao, fetchTreinametos, fetchVersoesLiberadas } from '.'
import { DefaultApiError } from '../types'
import { TreinamentosFilters, TreinamentosResponse } from '../../types/cliente/treinamentos/types'
import { Contact } from '../../types/cliente/contatos/types';
import { ReleasedVersionsFilters, ReleasedVersionsResponse } from '../../types/cliente/versoes/types'
import { CustomerFeedbackRequest, FeedbackRequest, PesquisaSatisfacao } from '../../types/cliente/feedback/feedback'


export const useFetchTreinamentos = (
    idCliente: number,
    filters: TreinamentosFilters,
    options?: Partial<UseQueryOptions<TreinamentosResponse, AxiosError<DefaultApiError>>>
) => useQuery<TreinamentosResponse, AxiosError<DefaultApiError>>({
    queryKey: ['treinamentos', idCliente, filters],
    queryFn: () => fetchTreinametos({ idCliente, filters }),
    ...options,
})


export const useFetchContatos = (
    idCliente: number,
    options?: Partial<UseQueryOptions<Contact[], AxiosError<DefaultApiError>>>
) => useQuery<Contact[], AxiosError<DefaultApiError>>({
    queryKey: ['contatos', idCliente],
    queryFn: () => fetchContatos(idCliente),
    ...options,
})


export const useFetchVersoesLiberadas = (
    idCliente: number,
    filters: ReleasedVersionsFilters,
    options?: Partial<UseQueryOptions<ReleasedVersionsResponse, AxiosError<DefaultApiError>>>
) => useQuery<ReleasedVersionsResponse, AxiosError<DefaultApiError>>({
    queryKey: ['versoesLiberadas', idCliente, filters],
    queryFn: () => fetchVersoesLiberadas({ idCliente, filters }),
    ...options,
})

export const useFetchPesquisaSatisfacao = (
    tipoAtendimento?: string,
    options?: Partial<UseQueryOptions<PesquisaSatisfacao, AxiosError<DefaultApiError>>>
) => useQuery<PesquisaSatisfacao, AxiosError<DefaultApiError>>({
    queryKey: ['pesquisaSatisfacao', tipoAtendimento],
    queryFn: () => {
        if (!tipoAtendimento) {
            throw new Error('Tipo de atendimento não informado');
        }
        return fetchPesquisaSatisfacao(tipoAtendimento);
    },
    ...options,
})




export const useCadastrarRetornoCliente = () =>
    useMutation<void, AxiosError<DefaultApiError>, FeedbackRequest>({
        mutationFn: cadastrarRetornoCliente,
    })

export const useCadastrarRepostaCliente = () =>
    useMutation<void, AxiosError<DefaultApiError>, CustomerFeedbackRequest>({
        mutationFn: cadastrarRepostaCliente,
    })



